import $ from 'jquery'
import { loadScript } from '@/utils/script'

const autoplayWhenVisible = function (
  elementId: string,
  videoId: string,
  videoAutoplay: boolean,
  videoLoop: boolean,
  videoDisableControls: boolean
): void {
  const videoElement = document.querySelector(`#${elementId}__player`)
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(function (entry) {
      const { isIntersecting, intersectionRatio } = entry
      if (isIntersecting || intersectionRatio > 0) {
        playVideo(
          elementId,
          videoId,
          videoAutoplay,
          videoLoop,
          videoDisableControls
        )
        observer.unobserve(entry.target)
      }
    })
  })

  if (videoElement) {
    observer.observe(videoElement)
  }
}

const playVideo = function (
  elementId: string,
  videoId: string,
  videoAutoplay: boolean,
  videoLoop: boolean,
  videoDisableControls: boolean
): void {
  const onPlayerReady = (event: YT.PlayerEvent) => {
    // The video is required to be muted in order to autoplay on mobile.
    event.target.mute()
    event.target.playVideo()
  }

  // Creates an <iframe> (and YouTube player) after the API code downloads.
  window.onYouTubeIframeAPIReady = () => {
    const playerVars: { [key: string]: unknown } = {
      // Always include autoplay because either the video will be autoplayed (i.e. immediately loaded), or the image
      // placeholder image and button will be shown first, and upon clicking the button, autoplay will be used to
      // start the video immediately.
      autoplay: 1,
      playsinline: 1,
      modestbranding: 1
    }

    if (videoLoop) {
      playerVars.playlist = videoId
      playerVars.loop = 1
    }

    if (videoDisableControls) {
      playerVars.controls = 0
    }

    new YT.Player(`${elementId}__player`, {
      videoId,
      playerVars,
      events: {
        onReady: onPlayerReady
      }
    })
  }

  loadScript('https://www.youtube.com/iframe_api')
}

export const init = function (
  elementId: string,
  videoId: string,
  videoAutoplay: boolean,
  videoLoop: boolean,
  videoDisableControls: boolean
): void {
  if (videoAutoplay) {
    autoplayWhenVisible(
      elementId,
      videoId,
      videoAutoplay,
      videoLoop,
      videoDisableControls
    )
  } else {
    $(`#${elementId} .youtube_video__play-button`).one('click', function () {
      $(
        `#${elementId} .youtube_video__play-button, #${elementId} .youtube_video__placeholder-image`
      ).remove()
      playVideo(
        elementId,
        videoId,
        videoAutoplay,
        videoLoop,
        videoDisableControls
      )
    })
  }
}
